import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/oneteg-new-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-a9946c32"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-bg" }, null, -1))
const _hoisted_2 = { class: "resetPassword" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-section" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "d-flex justify-content-center align-content-center flex-column height-100" }
const _hoisted_5 = { class: "description text-align-center" }

import { onMounted, ref, watch, watchEffect } from "vue";
import { ElButton, ElForm, ElFormItem, ElInput } from "element-plus";
import { router, currentRoute } from "@/core/router";
import { changeLocale } from "@/core/i18n";
import { isUserLoggedIn, resetPassword } from "@/core/auth";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const { t } = i18n.global;

const loading = ref(false);

const formUser = ref({
  username: "",
  email: "",
});

const wasSent = ref(false);

const formRules = ref({
  username: [
    {
      required: true,
      message: t("Auth.InputUser"),
      trigger: "blur",
    },
    {
      type: "email",
      message: t("Auth.EmailVal"),
      trigger: "blur",
    },
  ],
  email: [
    {
      required: true,
      message: "Please input email",
      trigger: "blur",
    },
  ],
});

const validValue = ref(false);

const elForm = ref<InstanceType<typeof ElForm>>();

onMounted(() => {
  if (isUserLoggedIn.value) {
    router.push("/");
  }

  watch(
    () => [formUser.value.username, formUser.value.email],
    () => {
      elForm.value.validate((valid) => {
        validValue.value = valid;
      });
    }
  );
});

const handleReset = async () => {
  loading.value = true;
  if (!wasSent.value) {
    const isSuccess = await resetPassword(formUser.value.email);
    if (isSuccess) {
      wasSent.value = true;
    }
  } else {
    await router.push("/login");
  }
  loading.value = false;
};

const redirectToLogin = () => {
  router.push("/login");
};

const selectedLocale = ref(currentRoute.value.params.locale as string);
watchEffect(() => changeLocale(selectedLocale.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(ElForm), {
          ref_key: "elForm",
          ref: elForm,
          model: formUser.value,
          rules: formRules.value,
          class: "margin",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              (!wasSent.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("Auth.ResetPasswordInstruction")), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("Auth.ResetPasswordSent")), 1)
                  ], 64))
            ]),
            (!wasSent.value)
              ? (_openBlock(), _createBlock(_unref(ElFormItem), {
                  key: 0,
                  class: "d-flex flex-column align-items-center justify-content-center form-item-center-input",
                  prop: "email",
                  label: _unref(t)('Common.Email')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElInput), {
                      modelValue: formUser.value.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formUser.value.email) = $event)),
                      class: "min-width"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(ElFormItem), { class: "d-flex flex-column align-items-center justify-content-center form-item-center-input" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  disabled: !validValue.value,
                  loading: loading.value,
                  class: "btn-primary width-350",
                  "native-type": "button",
                  size: "large",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleReset()))
                }, {
                  default: _withCtx(() => [
                    (!wasSent.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(t)("Common.ResetPassword")), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(t)("Common.GoBackToLogin")), 1)
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]),
                (!wasSent.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "forgotPasswordText",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (redirectToLogin()))
                    }, _toDisplayString(_unref(t)("Auth.BackLogin")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 64))
}
}

})